"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactI18next = require("react-i18next");
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));
var _LocalTaxi = _interopRequireDefault(require("@material-ui/icons/LocalTaxi"));
var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));
var _excluded = ["icon", "content"];
var RentalCarPane = function RentalCarPane(_ref) {
  var title = _ref.title,
    pickupTime = _ref.pickupTime,
    dropoffTime = _ref.dropoffTime,
    provider = _ref.provider,
    reservationNumber = _ref.reservationNumber,
    phoneNumber = _ref.phoneNumber,
    destination = _ref.destination;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _ref2 = [(0, _moment["default"])(pickupTime), (0, _moment["default"])(dropoffTime)],
    pickupMoment = _ref2[0],
    dropoffMoment = _ref2[1];
  var _ref3 = [pickupMoment.format('MMM DD'), dropoffMoment.format('MMM DD')],
    pickupDate = _ref3[0],
    dropoffDate = _ref3[1];
  var _ref4 = [pickupMoment.format('dddd'), dropoffMoment.format('dddd')],
    pickupDay = _ref4[0],
    dropoffDay = _ref4[1];
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_LocalTaxi["default"], {
      fontSize: "small"
    }),
    content: provider
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], {
      fontSize: "small"
    }),
    content: "".concat(pickupDate, " - ").concat(pickupDate)
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], {
      fontSize: "small"
    }),
    content: reservationNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], {
      fontSize: "small"
    }),
    content: phoneNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_LocationOn["default"], {
      fontSize: "small"
    }),
    content: destination ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "whitespace-pre-wrap"
    }, destination) : null,
    valign: 'top'
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "px-6 text-dark font-bold text-lg truncate"
  }, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    size: "sm",
    from: {
      label: t('sifts.modals.rentalcar.pickup'),
      text: pickupDate,
      subText: pickupDay
    },
    to: {
      label: t('sifts.modals.rentalcar.dropoff'),
      text: dropoffDate,
      subText: dropoffDay
    }
  }), items.map(function (_ref5, index) {
    var icon = _ref5.icon,
      content = _ref5.content,
      rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({
      key: index,
      size: "sm",
      icon: icon
    }, rest), content);
  }));
};
var _default = exports["default"] = RentalCarPane;
//# sourceMappingURL=RentalCar.js.map